<template>
	<el-drawer title="生成结款单" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
		@close="close">
		<div class="drawer-content">
			<el-form v-if="ContractList && selectContract && form1.step === 1 " :model="form1" ref="form1"
				label-position="top" size="medium">
				<div class="page-group-title">确认合同</div>
				<el-radio-group v-model="form1.keyId" size="medium" class="MT20">
					<el-radio v-for="(item,index) in ContractList" :key="index" :label="item.id">
						{{item.contractSn}} {{item.bankAccount}} {{item.bankAddress}}
					</el-radio>
				</el-radio-group>
			</el-form>
			<el-form v-if="form1.step === 2 " :model="form1" ref="form1" label-position="top" size="medium">
				<div class="page-group-title">确认场次</div>
				<div class="MT10">
					1.秀动支持按场次申请结款, 只有已结束且未申请过的场次, 可以申请结款.<br>
					2.通票只有在演出已结束的情况下, 跟随演出最后一个场次一起结款.
				</div>
				<div class="page-list-box">
					<el-table :data="SessionList" border style="width: 100%" v-loading="listLoading" size="small" stripe
						@selection-change="handleSelectionChange">
						<el-table-column type="selection" :selectable="selectable"></el-table-column>
						<el-table-column prop="sessionName" label="场次名称" min-width="150"
							show-overflow-tooltip></el-table-column>
						<el-table-column prop="endTimeView" label="场次结束时间" min-width="150"
							show-overflow-tooltip></el-table-column>
						<el-table-column prop="settlementStatus" label="结算状态" width="130">
							<template slot-scope="scope">
								<span v-if="scope.row.settlementStatus == 1">可结算</span>
								<span v-else-if="scope.row.settlementStatus == 2">场次未结束</span>
								<span v-else-if="scope.row.settlementStatus == 3">已申请</span>
								<span v-else-if="scope.row.settlementStatus == 4">已结款</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-form>			
		</div>
		<div class="drawer-footer">
			<template v-if="form1.step == 1 ">
				<el-button type="primary" @click="next()" icon="el-icon-right">下一步</el-button>
			</template>			
			<template v-if="form1.step == 2 ">
				<el-button type="primary" @click="form1.step = 1 " icon="el-icon-back" v-if="selectContract">上一步</el-button>
				<el-button type="primary" @click="submitForm()" :loading="btnLoading">申请结款</el-button>
			</template>
			<el-button @click="close">关闭</el-button>
		</div>
	</el-drawer>
</template>

<script>
	export default {
		data() {
			return {
				drawerShow: false,
				btnLoading: false,
				listLoading: false,				
				activityData: null,				
				selectContract: '',
				ContractList: [],
				SessionList: [],
				checkedSessionList: [],
				keyId: '',
				form1: {
					keyId: '',
					step: 1,
				},
			}
		},
		methods: {
			close() {
				if (this.$refs.formData) this.$refs.formData.resetFields();
				this.receivablesAudiInfo = null;
				this.drawerShow = false;
				this.form1 = {
					step: 1,
					keyId: ''
				};
				this.ContractList = []
				this.SessionList = []				
			},
			show(activityData) {

				this.activityData = activityData;
				this.selectContract = this.activityData.selectContract

				if (this.selectContract) {
					this.form1.step = 1
					this.getContractList()
				}
				if (!this.selectContract) {
					this.form1.step = 2
					this.getSessionList()
				}

				this.drawerShow = true;
			},
			selectable(row) {
				if (row.settlementStatus === 1) {
					return true;
				} else {
					return false;
				}

			},
			handleSelectionChange(val) {
				this.checkedSessionList = val
			},
			next() {
				if (this.selectContract && this.form1.step == 1 && this.form1.keyId == '') {
					return this.$message.error("请先选择合同!");
				} else {
					this.form1.step = 2
					this.getSessionList()
				}
			},
						
			getContractList() {
				this.$request({
						url: "/activityFinanceSettle/contractList",
						method: "POST",
						params: {
							activityId: this.activityData.id
						}
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.ContractList = result;

						} else {
							this.$message.error(msg || "获取合同信息失败");
						}
					})
					.catch(() => {
						this.$message.error("获取合同信息错误");
					})
					.finally(() => {});
			},
			getSessionList() {
				this.listLoading = true
				this.$request({
						url: "/activityFinanceSettle/applySessionList",
						method: "POST",
						params: {
							activityId: this.activityData.id
						}
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.SessionList = result;
							this.listLoading = false
						} else {
							this.$message.error(msg || "获取合同信息失败");
							this.listLoading = false
						}
					})
					.catch(() => {
						this.$message.error("获取合同信息错误");
					})
					.finally(() => {});
			},

			//表单提交
			submitForm() {
				if ( this.checkedSessionList && this.checkedSessionList.length == 0 ) {
					return this.$message.error("请先选择场次!");
				}
				const _url = "/activityFinanceSettle/submitAudiInfo";
				var _contractId = this.form1.keyId ? this.form1.keyId : '',
					_sessionIds = [];
				this.checkedSessionList.map(v => {
					_sessionIds.push(v.sessionId)
				})
				this.btnLoading = true;
				this.$request({
						url: _url,
						data: {
							activityId: this.activityData.id,
							contractId: _contractId,
							remark: this.remark,
							sessionIds: _sessionIds
						},
						method: "post",
					})
					.then((res) => {
						const {
							state,
							msg
						} = res.data;
						if (state == 1) {
							this.$message.success("提交成功");
							this.$emit('onUpdate');
							this.close();
						} else {
							this.$message.error(msg || "操作失败,请重试");
						}
					})
					.catch(() => {
						this.$message.error("操作失败,请重试");
					})
					.finally(() => {
						this.btnLoading = false;
					});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.img {
		.el-image {
			width: 100px;
			height: 100px;
			margin-right: 10px;
		}
	}

	th {
		width: 130px;
		white-space: nowrap;
	}

	.info-table th {
		padding: 8px 0 8px 10px;
		text-align: left;
	}

	.info-table td {
		border-right: 1px solid #eee;
		padding: 8px 0 8px 10px;
	}

	::v-deep .el-radio {
		display: block;
		margin-bottom: 10px;
	}
</style>